<template>
<div>
    <HeaderContent header="คำสั่งซื้อ" :img_header="header_image" :link_back="linkBack" />
    <ContentOrderDetailList />
</div>
</template>

<script>
import HeaderImage from '@/assets/box.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import ContentOrderDetailList from '@/components/menuadmin/content/contentpurchase/ContentOrderDetailList.vue'

export default {
    name: 'contentOrderDetail',
    components: {
        HeaderContent,
        ContentOrderDetailList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    },
    computed: {
        linkBack() {
            let link = 'contentorder'
            if (this.$route.params.type == 'orderretrospect') {
                link = 'contentretrospect'
            }
            return link
        }
    }
}
</script>
